import { useState, useEffect } from 'react';
import Page from '../components/Page';
import image from '../static/images/rules.png';


const HouseRules = (props) => {


  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');

  useEffect(() => {
    fetch('./content/houserules-NL.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/houserules-EN.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>


  document.title = props.langNL ? 'Huisregels - De School Amsterdam' : 'House Rules - De School Amsterdam';
  const headerTitle = props.langNL ? 'Huisregels' : 'House Rules';
  const description = props.langNL ? 'HUISREGELS HUISREGELS HUISREGELS HUISREGELS HUISREGELS HUISREGELS ' :
  'HOUSE RULES HOUSE RULES HOUSE RULES HOUSE RULES HOUSE';






  return <Page
          headerTitle={headerTitle}
          description={description}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}/>


};

export default HouseRules;
